import * as z from 'zod';
import { queryObjectSchema } from './complex-data-lookup/types';

// Parsed rather than asserted: a variable missing `__formula` would otherwise reach the variables
// panel and break it. At least one query, or applying the result would blank the lookup with no
// feedback.
export const lookupResultSchema = z.object({
  dataset: z.string(),
  queries: z.array(queryObjectSchema).min(1),
  variables: z.record(z.object({ __formula: z.string() })),
});

export type LookupResult = z.infer<typeof lookupResultSchema>;
